"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import Aseel_z_earthing from '../components/Aseel_z_earthing';
import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import zban from '../images/earthing/zinc_z/zinc_coated_page_banner.jpg';
import zban_360 from '../images/earthing/zinc_z/zinc_coated_page_banner_360.jpg';
import zban_tab from '../images/earthing/zinc_z/zinc_coated_page_banner_tab.jpg';
import zban_2x from '../images/earthing/zinc_z/zinc_coated_page_banner@2x.jpg';

// import ProducthomeBanner from '../components/ProducthomeBanner';
// import ban1x from '../images/producthome/product-home-banner.jpg';
// import ban2x from '../images/producthome/product-home-banner@2x.jpg';
const CarboformconductoPage = () => {
    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Ashlok Safe Earthing Electrode Limited - Zinc Coated Electrodes for superior corrosion resistance and long-lasting earthing solutions" apostropheBefore=""  apostropheAfter="" ban1x={zban} ban2x={zban_2x} ban360={zban_360} bantab={zban_tab}/>
                <ProductsubMenu/>
          <Aseel_z_earthing/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default CarboformconductoPage
 
